import i18n from '../i18n/config';
import { useTranslation } from 'react-i18next';
// frontend/src/pages/KitDetailPage.jsx - NUEVA PÁGINA PARA KITS
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Grid,
    Box,
    Typography,
    Button,
    Card,
    CardMedia,
    Chip,
    Divider,
    TextField,
    IconButton,
    Alert,
    Breadcrumbs,
    Link,
    Paper,
    CircularProgress,
    Skeleton,
    Stack,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    alpha,
    useTheme,
    Menu,
    MenuItem,
    ListItemIcon,
} from '@mui/material';
import {
    Add as AddIcon,
    Remove as RemoveIcon,
    ShoppingCart as CartIcon,
    Share as ShareIcon,
    ArrowBack as BackIcon,
    LocalShipping as ShippingIcon,
    Security as SecurityIcon,
    VerifiedUser as VerifiedIcon,
    CheckCircle as CheckIcon,
    NavigateNext as NavigateNextIcon,
    Inventory as InventoryIcon,
    ContentCopy as ContentCopyIcon,
    WhatsApp as WhatsAppIcon,
    Email as EmailIcon,
    Facebook as FacebookIcon,
    Telegram as TelegramIcon,
    Twitter as TwitterIcon,
} from '@mui/icons-material';

import { ecommerceApi, cartHelpers } from '../services/ecommerceApi';
import { useCart } from '../hooks/useCart';
import { useNotification } from '../components/common/GlobalNotifications';

const KitDetailPage = () => {
  const { t } = useTranslation();
    const { kitId } = useParams();
    const navigate = useNavigate();
    const theme = useTheme();
    const { addToCart, isInCart, getCartItemQuantity, openCartDrawer } = useCart();

    const { showSuccess, showError } = useNotification();

    const [kit, setKit] = useState(null);
    const [loading, setLoading] = useState(true);
    const [quantity, setQuantity] = useState(1);
    const [selectedImage, setSelectedImage] = useState(0);
    const [addingToCart, setAddingToCart] = useState(false);
    const [shareAnchorEl, setShareAnchorEl] = useState(null);
    const inCart = isInCart(kit?.id, 'kit');
    const cartQuantity = getCartItemQuantity(kit?.id, 'kit');




    useEffect(() => {
        if (!kitId || kitId === 'undefined' || kitId === 'null') {
            showError(t('hardcoded.pages_kitdetailpage.id_de_kit_invalido'));
            navigate('/store');
            return;
        }
        loadKit();
    }, [kitId, navigate, showError]);

    async function loadKit() {
        setLoading(true);
        try {
            const response = await ecommerceApi.kits.getById(kitId);
            const kitData = response.data;

            const missingDetails = (kitData.products || []).some((line) => {
                const name = line?.product?.name || line?.name;
                const sku = line?.product?.sku || line?.sku;
                return !name || !sku;
            });

            if (missingDetails && Array.isArray(kitData.products) && kitData.products.length > 0) {
                try {
                    const productsResponse = await ecommerceApi.kits.getProducts(kitId);
                    const products = productsResponse?.data || [];
                    const byId = new Map(products.map((p) => [String(p.id), p]));

                    kitData.products = kitData.products.map((line) => {
                        const productId = String(line.product_id || line.product?.id || '');
                        const hydrated = byId.get(productId);
                        if (!hydrated) return line;
                        return {
                            ...line,
                            name: line.name || hydrated.name,
                            sku: line.sku || hydrated.sku,
                            product: {
                                ...hydrated,
                                ...(line.product || {}),
                                name: hydrated.name,
                                sku: hydrated.sku,
                                stock_quantity: hydrated.stock_quantity,
                                restock_eta_days: hydrated.restock_eta_days,
                            },
                            stock_available: line.stock_available ?? hydrated.stock_quantity,
                            stock_missing: line.stock_missing ?? Math.max(0, Number(line.quantity || 0) - Number(hydrated.stock_quantity || 0)),
                            restock_eta_days: line.restock_eta_days ?? hydrated.restock_eta_days,
                        };
                    });
                } catch (hydrationError) {
                    console.warn('Kit products hydration fallback failed:', hydrationError);
                }
            }

            setKit(kitData);
        } catch (error) {
            console.error(t('hardcoded.pages_kitdetailpage.error_loading_kit'), error);
            showError(t('hardcoded.pages_kitdetailpage.error_al_cargar_el_kit'));
            navigate('/store');
        } finally {
            setLoading(false);
        }
    }

    const handleShare = async () => {
        const shareUrl = window.location.href;
        try {
            if (navigator.share) {
                await navigator.share({
                    title: kit?.name || t('hardcoded.pages_kitdetailpage.kit_arsenal_tpms'),
                    text: kit?.description || t('hardcoded.pages_kitdetailpage.revisa_este_kit'),
                    url: shareUrl,
                });
                return;
            }
            await navigator.clipboard.writeText(shareUrl);
            showSuccess(t('hardcoded.pages_kitdetailpage.enlace_copiado_al_portapapeles'));
        } catch (err) {
            showError(t('hardcoded.pages_kitdetailpage.no_se_pudo_compartir_el'));
        }
    };

    const handleOpenShareMenu = (event) => setShareAnchorEl(event.currentTarget);
    const handleCloseShareMenu = () => setShareAnchorEl(null);

    const openShareLink = async (type) => {
        const url = window.location.href;
        const title = encodeURIComponent(kit?.name || t('hardcoded.pages_kitdetailpage.kit_arsenal_tpms'));
        const encodedUrl = encodeURIComponent(url);

        if (type === 'copy') {
            await handleShare();
            handleCloseShareMenu();
            return;
        }

        const links = {
            whatsapp: `https://wa.me/?text=${title}%20${encodedUrl}`,
            email: `mailto:?subject=${title}&body=${encodedUrl}`,
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
            x: `https://twitter.com/intent/tweet?text=${title}&url=${encodedUrl}`,
            telegram: `https://t.me/share/url?url=${encodedUrl}&text=${title}`,
        };

        const target = links[type];
        if (target) {
            window.open(target, t('hardcoded.components_operators_operatorcontactmenu._blank'), t('hardcoded.components_operators_operatorcontactmenu.noopenernoreferrer'));
        }
        handleCloseShareMenu();
    };

    const handleAddToCart = async () => {
        setAddingToCart(true);
        try {
            await addToCart({
                kit_id: kit.id,
                quantity: quantity
            });

            showSuccess(t('hardcoded.pages_kitdetailpage.kit_name_agregado_al_carrito', { name: kit.name }));
            openCartDrawer();
            setQuantity(1);
        } catch (error) {
            showError(error.message || t('hardcoded.components_store_productcard.error_al_agregar_al_carrito'));
        } finally {
            setAddingToCart(false);
        }
    };


    const handleQuantityChange = (newQuantity) => {
        if (newQuantity < 1) return;
        setQuantity(newQuantity);
    };

    if (loading) {
        return (
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Skeleton variant="rectangular" height={500} sx={{ borderRadius: 2 }} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Skeleton variant="text" height={50} />
                        <Skeleton variant="text" height={30} width="60%" />
                        <Skeleton variant="rectangular" height={100} sx={{ my: 2 }} />
                        <Skeleton variant="rectangular" height={60} />
                    </Grid>
                </Grid>
            </Container>
        );
    }

    if (!kit) {
        return (
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Alert severity="error">{t('hardcoded.pages_kitdetailpage.kit_no_encontrado')}</Alert>
            </Container>
        );
    }

    const allImages = kit.images && kit.images.length > 0 ?
        kit.images :
        [kit.main_image || '/images/kit-placeholder.jpg'];

    const savingsAmount = kit.compare_price ? kit.compare_price - kit.price : 0;
    const discountPercentage = kit.compare_price ? Math.round((savingsAmount / kit.compare_price) * 100) : 0;

    return (
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 4 }}>
            <Container maxWidth="lg">
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 3 }}>
                    <Link
                        color="inherit"
                        href="/store"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate('/store');
                        }}
                        sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                    >
                        {i18n.t('hardcoded.components_common_sidebar.tienda')}</Link>
                    <Typography color="text.primary">{kit.name}</Typography>
                </Breadcrumbs>

                <Button startIcon={<BackIcon />} onClick={() => navigate(-1)} sx={{ mb: 3 }}>
                    {i18n.t('hardcoded.components_operators_operatorquickcreateform.volver')}</Button>

                <Grid container spacing={4}>
                    {/* Images */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{ position: 'sticky', top: 20 }}>
                            <Paper elevation={2} sx={{ mb: 2, overflow: 'hidden', borderRadius: 2, position: 'relative' }}>
                                <CardMedia
                                    component="img"
                                    height="500"
                                    image={allImages[selectedImage]}
                                    alt={kit.name}
                                    sx={{ objectFit: 'cover', backgroundColor: 'grey.100' }}
                                />

                                {savingsAmount > 0 && (
                                    <Chip
                                        label={`-${discountPercentage}%`}
                                        color="error"
                                        sx={{
                                            position: 'absolute',
                                            top: 16,
                                            left: 16,
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                            px: 1
                                        }}
                                    />
                                )}
                                {kit.is_featured && (
                                    <Chip
                                        label={t('hardcoded.components_store_productcard.destacado')}
                                        color="primary"
                                        sx={{ position: 'absolute', top: 16, right: 16, fontWeight: 600 }}
                                    />
                                )}
                                <Chip
                                    label={t('hardcoded.pages_kitdetailpage.kit_badge')}
                                    color="secondary"
                                    sx={{ position: 'absolute', bottom: 16, left: 16, fontWeight: 600 }}
                                />
                                <IconButton
                                    size="small"
                                    onClick={handleOpenShareMenu}
                                    sx={{
                                        position: 'absolute',
                                        top: 16,
                                        right: 16,
                                        bgcolor: 'rgba(255,255,255,0.92)',
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        '&:hover': { bgcolor: 'white' }
                                    }}
                                >
                                    <ShareIcon fontSize="small" />
                                </IconButton>
                                <Menu anchorEl={shareAnchorEl} open={Boolean(shareAnchorEl)} onClose={handleCloseShareMenu}>
                                    <MenuItem onClick={() => openShareLink('copy')}>
                                        <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
                                        <ListItemText>{i18n.t('inviteUser.success.copyLink')}</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={() => openShareLink('whatsapp')}>
                                        <ListItemIcon><WhatsAppIcon fontSize="small" /></ListItemIcon>
                                        <ListItemText>{t('pages_kitdetailpage.share_whatsapp')}</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={() => openShareLink('email')}>
                                        <ListItemIcon><EmailIcon fontSize="small" /></ListItemIcon>
                                        <ListItemText>{i18n.t('hardcoded.components_settings_companynetworkstab.correo')}</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={() => openShareLink('facebook')}>
                                        <ListItemIcon><FacebookIcon fontSize="small" /></ListItemIcon>
<ListItemText>{t('pages_kitdetailpage.share_facebook')}</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={() => openShareLink('x')}>
                                        <ListItemText>{t('pages_kitdetailpage.share_x')}</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={() => openShareLink('telegram')}>
                                        <ListItemIcon><TelegramIcon fontSize="small" /></ListItemIcon>
                                        <ListItemText>{i18n.t('hardcoded.pages_kitdetailpage.telegram')}</ListItemText>
                                    </MenuItem>
                                </Menu>
                            </Paper>

                            {allImages.length > 1 && (
                                <Stack direction="row" spacing={1} sx={{ overflowX: 'auto', pb: 1 }}>
                                    {allImages.map((image, index) => (
                                        <Paper
                                            key={index}
                                            elevation={selectedImage === index ? 4 : 1}
                                            sx={{
                                                minWidth: 80,
                                                cursor: 'pointer',
                                                border: '2px solid',
                                                borderColor: selectedImage === index ? 'primary.main' : 'transparent',
                                                borderRadius: 1,
                                                overflow: 'hidden',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    borderColor: 'primary.light',
                                                    transform: 'scale(1.05)'
                                                }
                                            }}
                                            onClick={() => setSelectedImage(index)}
                                        >
                                            <CardMedia
                                                component="img"
                                                height="80"
                                                image={image}
                                                alt={`${kit.name} ${index + 1}`}
                                                sx={{ objectFit: 'cover' }}
                                            />
                                        </Paper>
                                    ))}
                                </Stack>
                            )}
                        </Box>
                    </Grid>

                    {/* Kit Info */}
                    <Grid item xs={12} md={6}>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <InventoryIcon color="primary" sx={{ fontSize: 32 }} />
                                <Chip label={t('hardcoded.pages_kitdetailpage.kit_de_productos')} color="secondary" />
                            </Box>

                            <Typography variant="h3" fontWeight={700} gutterBottom>
                                {kit.name}
                            </Typography>

                            <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 3 }}>
                                <Typography variant="body2" color="text.secondary">
                                    {t('hardcoded.pages_kitdetailpage.sku_label')} <strong>{kit.sku}</strong>
                                </Typography>
                                <Chip
                                    label={t('hardcoded.pages_kitdetailpage.kitproductsleng_productos_incluidos', { kitproductsleng: kit.products?.length || 0 })}
                                    color="info"
                                    icon={<CheckIcon />}
                                    size="small"
                                />
                            </Stack>

                            {/* Pricing */}
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 3,
                                    mb: 3,
                                    bgcolor: alpha(theme.palette.primary.main, 0.05),
                                    border: '2px solid',
                                    borderColor: alpha(theme.palette.primary.main, 0.1),
                                    borderRadius: 2
                                }}
                            >
                                <Stack direction="row" alignItems="baseline" spacing={2} flexWrap="wrap">
                                    <Typography variant="h3" color="primary" fontWeight={700}>
                                        {cartHelpers.formatCurrency(kit.price)}
                                    </Typography>
                                    {savingsAmount > 0 && (
                                        <>
                                            <Typography
                                                variant="h5"
                                                color="text.secondary"
                                                sx={{ textDecoration: 'line-through' }}
                                            >
                                                {cartHelpers.formatCurrency(kit.compare_price)}
                                            </Typography>
                                            <Chip
                                                label={t('hardcoded.pages_kitdetailpage.ahorras_carthelpersform', { cartHelpersform: cartHelpers.formatCurrency(savingsAmount) })}
                                                color="success"
                                                size="small"
                                            />
                                        </>
                                    )}
                                </Stack>
                            </Paper>

                            {/* Description */}
                            {kit.description && (
                                <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.8 }}>
                                    {kit.description}
                                </Typography>
                            )}

                            {/* Products Included */}
                            {kit.products && kit.products.length > 0 && (
                                <Box sx={{ mb: 3 }}>
                                    <Typography variant="h6" fontWeight={600} gutterBottom>
                                        {i18n.t('hardcoded.pages_kitdetailpage.productos_incluidos')}</Typography>
                                    <Paper elevation={1} sx={{ maxHeight: 300, overflow: 'auto' }}>
                                        <List>
                                            {kit.products.map((item, index) => (
                                                <ListItem
                                                    key={index}
                                                    sx={{
                                                        borderBottom: index < kit.products.length - 1 ? '1px solid' : 'none',
                                                        borderColor: 'divider'
                                                    }}
                                                >
                                                    <ListItemAvatar>
                                                        <Avatar
                                                            src={item.product?.main_image_url || '/images/placeholder-product.jpg'}
                                                            alt={item.product?.name}
                                                            variant="rounded"
                                                            sx={{ width: 60, height: 60 }}
                                                        />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="subtitle1" fontWeight={600}>
                                                                {item.product?.name || item.name}
                                                            </Typography>
                                                        }
                                                        secondary={
                                                            <Box>
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {t('hardcoded.pages_kitdetailpage.qty_label')} {item.quantity} - {item.product?.name || item.name}
                                                                </Typography>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    {t('hardcoded.pages_adminstorepage.stock')}{item.stock_available ?? '-'} {i18n.t('hardcoded.pages_kitdetailpage.faltante')}{item.stock_missing ?? '-'}
                                                                    {item.restock_eta_days ? t('hardcoded.pages_kitdetailpage.eta_restock_eta_days_dias', { restock_eta_days: item.restock_eta_days }) : ''}
                                                                </Typography>
                                                                {item.product?.price && (
                                                                    <Typography variant="body2" color="primary" fontWeight={600}>
                                                                        {cartHelpers.formatCurrency(item.product.price * item.quantity)}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        }
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Paper>
                                </Box>
                            )}

                            {/* Quantity Selector */}
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                                    {t('hardcoded.components_store_cartitemline.cantidad')}</Typography>
                                <Paper
                                    elevation={1}
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 2
                                    }}
                                >
                                    <IconButton
                                        onClick={() => handleQuantityChange(quantity - 1)}
                                        disabled={quantity <= 1}
                                        sx={{ borderRadius: '8px 0 0 8px' }}
                                    >
                                        <RemoveIcon />
                                    </IconButton>
                                    <TextField
                                        value={quantity}
                                        onChange={(e) => handleQuantityChange(parseInt(e.target.value) || 1)}
                                        inputProps={{
                                            min: 1,
                                            style: { textAlign: 'center', width: '60px', fontWeight: 600 }
                                        }}
                                        variant="standard"
                                        sx={{
                                            '& .MuiInput-underline:before': { display: 'none' },
                                            '& .MuiInput-underline:after': { display: 'none' }
                                        }}
                                    />
                                    <IconButton
                                        onClick={() => handleQuantityChange(quantity + 1)}
                                        sx={{ borderRadius: '0 8px 8px 0' }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </Paper>
                            </Box>

                            {/* Action Buttons */}
                            <Stack direction="row" spacing={2} sx={{ mb: 4 }}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    startIcon={addingToCart ? <CircularProgress size={20} color="inherit" /> : <CartIcon />}
                                    onClick={handleAddToCart}
                                    disabled={addingToCart}
                                    sx={{
                                        flex: 1,
                                        py: 2,
                                        fontSize: '1.1rem',
                                        fontWeight: 700,
                                        textTransform: 'none',
                                        boxShadow: 3,
                                        '&:hover': { boxShadow: 6 }
                                    }}
                                >
                                    {addingToCart ? t('hardcoded.components_store_productcard.agregando') :
                                        inCart ? t('hardcoded.pages_kitdetailpage.agregar_mas_cartquantity_en_carrito', { cartQuantity: cartQuantity }) :
                                            t('hardcoded.pages_kitdetailpage.agregar_kit_al_carrito')}
                                </Button>
                            </Stack>

                            {/* Trust Badges */}
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    bgcolor: 'grey.50',
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'divider'
                                }}
                            >
                                <Stack spacing={2}>
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <VerifiedIcon color="primary" />
                                        <Box>
                                            <Typography variant="body2" fontWeight={600}>
                                                {t('hardcoded.pages_kitdetailpage.garantia_de_calidad_arsenal')}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {i18n.t('hardcoded.pages_kitdetailpage.productos_certificados_y_originales')}</Typography>
                                        </Box>
                                    </Stack>
                                    <Divider />
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <ShippingIcon color="primary" />
                                        <Box>
                                            <Typography variant="body2" fontWeight={600}>
                                                {t('hardcoded.pages_kitdetailpage.envio_rapido')}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {t('hardcoded.pages_kitdetailpage.entrega_en_3-5_dias_habiles')}</Typography>
                                        </Box>
                                    </Stack>
                                    <Divider />
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <SecurityIcon color="primary" />
                                        <Box>
                                            <Typography variant="body2" fontWeight={600}>
                                                {i18n.t('hardcoded.pages_kitdetailpage.compra_segura')}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {t('hardcoded.pages_kitdetailpage.proteccion_en_cada_transaccion')}</Typography>
                                        </Box>
                                    </Stack>
                                </Stack>
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

        </Box>
    );
};

export default KitDetailPage;